import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";

export interface IComunidadesAutonomasChartState {
    data: any[];
}

export default class ComunidadesAutonomasChart extends React.Component<{}, IComunidadesAutonomasChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Comunidades autónomas
                        </Typography>
                        <Button variant='text' onClick={() => {
                            window.location.href = '/summary/comunidadesautonomas'
                        }}>
                            Ver todas
                        </Button>
                    </Box>
                    <PieChart
                        height={450}
                        margin={{
                            left: 100,
                            right: 100,
                            bottom: 250,
                            top: 100
                        }}
                        series={[
                            { 
                                data: this.state.data,
                                innerRadius: 90,
                                outerRadius: 140,
                                paddingAngle: 0,
                                highlightScope: { faded: 'global', highlighted: 'item' },
                                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' }
                            }
                        ]}
                        slotProps={
                            {
                                legend: {
                                    direction: 'row',
                                    position: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    },
                                    itemMarkWidth: 20,
                                    itemMarkHeight: 12,
                                    markGap: 5,
                                    itemGap: 10,
                                    labelStyle: {
                                        fontSize: 11
                                    }
                                }
                            }
                        }
                    />
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const colors = Common.FIELD_PALETTE_MAP.find((x => x.field == 'comunidadautonoma')).colors;
            const gradientArray = new Gradient()
            .setColorGradient(colors[0], colors[1])
            .setMidpoint(response.length)
            .getColors();

            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.id = i;
                dataItem.value = response[i].total;
                dataItem.label = response[i].comunidadAutonoma;
                dataItem.color = gradientArray[i];

                data.push(dataItem);
            }

            this.setState(
                {
                    data: data
                }
            );
        })
    }
}